module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/location_type_resort@2x-70a94e735026188ef635cc95a69b15d9.webp";